import postOfficeTemplate from '@post-office/team-package--i18n--post-office-template/i18n/es.json';
import growth from '@post-office/team-package--i18n--growth/i18n/es.json';
import testMessages from '@post-office/team-package--i18n--test-messages/i18n/es.json';

export default {
	...postOfficeTemplate,
	...growth,
	...testMessages
}
